// DEVELOPED BY TAHA HUSSAIN
export class AppError {
    constructor(public originalError?: any){}
}